import React from 'react';
// import { Icon } from 'antd';
import Icon from '@ant-design/icons';
import SpectreIconPng from '../../images/speechsheet/spectre_icon.png';
import BowlerIconPngWhite from '../../images/speechsheet/icon_bowler_white.png';
import BowlerIconPngBlue from '../../images/speechsheet/icon_bowler_blue.png';
import HandIconPngWhite from '../../images/speechsheet/icon_hand_white.png';
import HandIconPngBlue from '../../images/speechsheet/icon_hand_blue.png';
import BallIconPngWhite from '../../images/speechsheet/icon_ball_white.png';
import BallIconPngBlue from '../../images/speechsheet/icon_ball_blue.png';
import ExportIconPngWhite from '../../images/speechsheet/icon-export-white.png';
import ExportIconPngBlue from '../../images/speechsheet/icon-export-blue.png';
import PrinterIconPngWhite from '../../images/speechsheet/icon_printer_white.png';
import PrinterIconPngBlue from '../../images/speechsheet/icon_printer_blue.png';
import SettingsIconPngWhite from '../../images/speechsheet/icon_settings_white.png';
import SettingsIconPngBlue from '../../images/speechsheet/icon_settings_blue.png';
import ProIconPng from '../../images/speechsheet/pro-icon.png';
import ProIconIOSPng from '../../images/speechsheet/pro-icon-ios.png';
import SpectreLogoPng from '../../images/speechsheet/logo-spectre-sidebar.png';
import BackupIconPng from '../../images/speechsheet/icon-export-white.png';
import RestoreIconPng from '../../images/speechsheet/icon_dropbox_white.png';
import RulerIconPngWhite from '../../images/speechsheet/icon_ruler_white.png';
import RulerIconPngBlue from '../../images/speechsheet/icon_ruler_white.png';
import FingerIconPngWhite from '../../images/speechsheet/icon_finger_white.png';
import FingerIconPngBlue from '../../images/speechsheet/icon_finger_white.png';
import ThumbIconPngWhite from '../../images/speechsheet/icon_thumb_white.png';
import ThumbIconPngBlue from '../../images/speechsheet/icon_thumb_white.png';
import NotesIconPngWhite from '../../images/speechsheet/icon_notes_white.png';
import NotesIconPngBlue from '../../images/speechsheet/icon_notes_white.png';
import FolderIconPngWhite from '../../images/speechsheet/icon_folder_white.png';
import FolderIconPngBlue from '../../images/speechsheet/icon_folder_white.png';
import CameraIconPngWhite from '../../images/speechsheet/icon_camera_white.png';
import AddIconPngWhite from '../../images/speechsheet/icon-add-white.png';
import SearchIconPngBlack from '../../images/speechsheet/search-black.png';
import TrashIconPngWhite from '../../images/speechsheet/trash-white.png';
import GalleryIconPngWhite from '../../images/speechsheet/gallery-white.png';
import PictureIconPngWhite from '../../images/speechsheet/picture-white.png';
import SpecSheetIconPngWhite from '../../images/speechsheet/spec-sheet-white.png';
import ArsenalIconPngWhite from '../../images/speechsheet/ball-white.png';
import ToggleIconPngWhite from '../../images/speechsheet/toggle-white.png';
import NoPhotoPersonIconPng from '../../images/speechsheet/picture-person.png';
import NoPhotoBallIconPng from '../../images/speechsheet/picture-ball.png';
import ListIconPngWhite from '../../images/speechsheet/icon-list-white.png';
import ListIconPngBlue from '../../images/speechsheet/icon-list-blue.png';
import NewCutPng from '../../images/speechsheet/sign_+.png';
import NewCutHalfPng from '../../images/speechsheet/half.png';
import NewCutQuarterPng from '../../images/speechsheet/quarter.png';
import NewCutHalfBackPng from '../../images/speechsheet/half-back.png';
import NewCutQuarterBackPng from '../../images/speechsheet/quarter-back.png';
import NewCutHalfFrontPng from '../../images/speechsheet/half-front.png';
import NewCutQuarterFrontPng from '../../images/speechsheet/quarter-front.png';
import DeleteCutPng from '../../images/speechsheet/sign_x.png';

const SpectreIconImage = () => <img src={SpectreIconPng} style={{ marginLeft: '-0.7em' }} />;

const BackupIconImage = () => <img src={BackupIconPng} style={{ width: '2.2em' }} />;

export const BackupIcon = () => <Icon component={BackupIconImage} />;

const RestoreIconImage = () => <img src={RestoreIconPng} style={{ width: '2.2em' }} />;

export const RestoreIcon = () => <Icon component={RestoreIconImage} />;

const ProIconImage = () => <img src={ProIconPng} style={{ marginLeft: '-0.7em' }} />;

export const ProIcon = () => <Icon component={ProIconImage} />;

const ProIconIOSImage = () => <img src={ProIconIOSPng} style={{ marginLeft: '-0.7em' }} />;

export const ProIconIOS = () => <Icon component={ProIconIOSImage} />;

export const SpectreLogoImage = () => (
  <img src={SpectreLogoPng} style={{ position: 'absolute', top: 'calc(100% - 240px)', marginLeft: '-0.7em' }} />
);

const menuIconStyle = { width: '5em', fontSize: '10px' };

const BowlerIconImageWhite = () => <img src={BowlerIconPngWhite} style={menuIconStyle} />;

const BowlerIconImageBlue = () => <img src={BowlerIconPngBlue} style={menuIconStyle} />;

const HandIconImageWhite = () => <img src={HandIconPngWhite} style={menuIconStyle} />;

const HandIconImageBlue = () => <img src={HandIconPngBlue} style={menuIconStyle} />;

const LeftHandIconImageWhite = () => (
  <img src={HandIconPngWhite} style={{ ...menuIconStyle, transform: 'scaleX(-1)' }} />
);

const LeftHandIconImageBlue = () => <img src={HandIconPngBlue} style={{ ...menuIconStyle, transform: 'scaleX(-1)' }} />;

const BallIconImageWhite = () => <img src={BallIconPngWhite} style={menuIconStyle} />;

const BallIconImageBlue = () => <img src={BallIconPngBlue} style={menuIconStyle} />;

const ExportIconImageWhite = () => <img src={ExportIconPngWhite} style={menuIconStyle} />;

const ExportIconImageBlue = () => <img src={ExportIconPngBlue} style={menuIconStyle} />;

const PrinterIconImageWhite = () => <img src={PrinterIconPngWhite} style={menuIconStyle} />;

const PrinterIconImageBlue = () => <img src={PrinterIconPngBlue} style={menuIconStyle} />;

const SettingsIconImageWhite = () => <img src={SettingsIconPngWhite} style={menuIconStyle} />;

const SettingsIconImageBlue = () => <img src={SettingsIconPngBlue} style={menuIconStyle} />;

const RulerIconImageWhite = () => <img src={RulerIconPngWhite} style={menuIconStyle} />;

const RulerIconImageBlue = () => <img src={RulerIconPngBlue} style={menuIconStyle} />;

const FingerIconImageWhite = () => <img src={FingerIconPngWhite} style={menuIconStyle} />;

const FingerIconImageBlue = () => <img src={FingerIconPngBlue} style={menuIconStyle} />;

const ThumbIconImageWhite = () => <img src={ThumbIconPngWhite} style={menuIconStyle} />;

const ThumbIconImageBlue = () => <img src={ThumbIconPngBlue} style={menuIconStyle} />;

const NotesIconImageWhite = () => <img src={NotesIconPngWhite} style={menuIconStyle} />;

const NotesIconImageBlue = () => <img src={NotesIconPngBlue} style={menuIconStyle} />;

const FolderIconImageWhite = () => <img src={FolderIconPngWhite} style={menuIconStyle} />;

const FolderIconImageBlue = () => <img src={FolderIconPngBlue} style={menuIconStyle} />;

const CameraIconImageWhite = () => <img src={CameraIconPngWhite} style={menuIconStyle} />;

const AddIconImageWhite = () => (
  <img
    src={AddIconPngWhite}
    style={{
      width: '5em',
      fontSize: '10px',
    }}
  />
);

const SearchIconImageBlack = () => (
  <img
    src={SearchIconPngBlack}
    style={{
      width: '1.4em',
      fontSize: '10px',
      marginLeft: '-0.7em',
      marginRight: '-1em',
    }}
  />
);

const TrashIconImageWhite = () => (
  <img
    src={TrashIconPngWhite}
    style={{
      width: '100%',
      fontSize: '10px',
      objectFit: 'none',
    }}
  />
);

const GalleryIconImageWhite = () => (
  <img
    src={GalleryIconPngWhite}
    style={{
      width: '100%',
      fontSize: '10px',
      objectFit: 'none',
    }}
  />
);

const PictureIconImageWhite = () => (
  <img
    src={PictureIconPngWhite}
    style={{
      width: '100%',
      fontSize: '10px',
      objectFit: 'none',
    }}
  />
);

const SpecSheetIconImageWhite = () => (
  <img
    src={SpecSheetIconPngWhite}
    style={{
      width: '100%',
      fontSize: '10px',
      objectFit: 'none',
    }}
  />
);

const ArsenalIconImageWhite = () => (
  <img
    src={ArsenalIconPngWhite}
    style={{
      width: '100%',
      fontSize: '10px',
      objectFit: 'none',
    }}
  />
);

const ToggleIconImageWhite = () => (
  <img
    src={ToggleIconPngWhite}
    style={{
      width: '100%',
      fontSize: '10px',
      objectFit: 'none',
    }}
  />
);

export const NoPhotoPersonIconImage = ({ style }) => (
  <img
    src={NoPhotoPersonIconPng}
    style={{
      fontSize: '10px',
      ...style,
    }}
  />
);

export const NoPhotoBallIconImage = ({ style }) => (
  <img
    src={NoPhotoBallIconPng}
    style={{
      fontSize: '10px',
      ...style,
    }}
  />
);

const ListIconImageWhite = () => (
  <img
    src={ListIconPngWhite}
    style={{
      width: '5em',
      fontSize: '10px',
    }}
  />
);

const ListIconImageBlue = () => (
  <img
    src={ListIconPngBlue}
    style={{
      width: '5em',
      fontSize: '10px',
    }}
  />
);

export const SpectreIcon = () => <Icon component={SpectreIconImage} />;

export const BowlerIcon = props => {
  const { isSelected } = props;
  return isSelected ? <Icon component={BowlerIconImageWhite} /> : <Icon component={BowlerIconImageBlue} />;
};

export const HandIcon = props => {
  const { isSelected } = props;
  return isSelected ? <Icon component={HandIconImageWhite} /> : <Icon component={HandIconImageBlue} />;
};

export const RightHandIcon = props => {
  const { isSelected } = props;
  return isSelected ? <Icon component={HandIconImageWhite} /> : <Icon component={HandIconImageBlue} />;
};

export const LeftHandIcon = props => {
  const { isSelected } = props;
  return isSelected ? <Icon component={LeftHandIconImageWhite} /> : <Icon component={LeftHandIconImageBlue} />;
};

export const BallIcon = props => {
  const { isSelected } = props;
  return isSelected ? <Icon component={BallIconImageWhite} /> : <Icon component={BallIconImageBlue} />;
};

export const ExportIcon = props => {
  const { isSelected } = props;
  return isSelected ? <Icon component={ExportIconImageWhite} /> : <Icon component={ExportIconImageBlue} />;
};

export const PrinterIcon = props => {
  const { isSelected } = props;
  return isSelected ? <Icon component={PrinterIconImageWhite} /> : <Icon component={PrinterIconImageBlue} />;
};

export const SettingsIcon = props => {
  const { isSelected } = props;
  return isSelected ? <Icon component={SettingsIconImageWhite} /> : <Icon component={SettingsIconImageBlue} />;
};

export const ListIcon = props => {
  const { isSelected } = props;
  return isSelected ? <Icon component={ListIconImageWhite} /> : <Icon component={ListIconImageBlue} />;
};

export const RulerIcon = () => <Icon component={RulerIconImageWhite} />;
export const FingerIcon = () => <Icon component={FingerIconImageWhite} />;
export const ThumbIcon = () => <Icon component={ThumbIconImageWhite} />;
export const NotesIcon = () => <Icon component={NotesIconImageWhite} />;
export const FolderIcon = () => <Icon component={FolderIconImageWhite} />;
export const CameraIcon = () => <Icon component={CameraIconImageWhite} />;
export const AddIcon = () => <Icon component={AddIconImageWhite} />;
export const SearchIcon = () => <Icon component={SearchIconImageBlack} />;
export const TrashIcon = () => <Icon component={TrashIconImageWhite} />;
export const SpecSheetIcon = () => <Icon component={SpecSheetIconImageWhite} />;
export const ArsenalIcon = () => <Icon component={ArsenalIconImageWhite} />;
export const NoPhotoPersonIcon = props => <Icon component={NoPhotoPersonIconImage} {...props} />;
export const NoPhotoBallIcon = props => <Icon component={NoPhotoPersonIconImage} {...props} />;
export const PictureIcon = props => <Icon component={PictureIconImageWhite} {...props} />;
export const GalleryIcon = props => <Icon component={GalleryIconImageWhite} {...props} />;

export const ToggleIcon = props => <Icon component={ToggleIconImageWhite} {...props} />;

const CutIconStyle = { height: '32px', fontSize: '10px' };

const NewCutIconImage = () => <img src={NewCutPng} style={CutIconStyle} />;
const NewCutHalfIconImage = () => <img src={NewCutHalfPng} style={CutIconStyle} />;
const NewCutQuarterIconImage = () => <img src={NewCutQuarterPng} style={CutIconStyle} />;
const NewCutHalfBackIconImage = () => <img src={NewCutHalfBackPng} style={CutIconStyle} />;
const NewCutQuarterBackIconImage = () => <img src={NewCutQuarterBackPng} style={CutIconStyle} />;
const NewCutHalfFrontIconImage = () => <img src={NewCutHalfFrontPng} style={CutIconStyle} />;
const NewCutQuarterFrontIconImage = () => <img src={NewCutQuarterFrontPng} style={CutIconStyle} />;

export const NewCutIcon = () => <Icon component={NewCutIconImage} />;
export const NewCutHalfIcon = () => <Icon component={NewCutHalfIconImage} />;
export const NewCutQuarterIcon = () => <Icon component={NewCutQuarterIconImage} />;
export const NewCutHalfBackIcon = () => <Icon component={NewCutHalfBackIconImage} />;
export const NewCutQuarterBackIcon = () => <Icon component={NewCutQuarterBackIconImage} />;
export const NewCutHalfFrontIcon = () => <Icon component={NewCutHalfFrontIconImage} />;
export const NewCutQuarterFrontIcon = () => <Icon component={NewCutQuarterFrontIconImage} />;
export const deleteIconStyle = {
  color: '#000',
  height: '28px',
  width: '28px',
  background: `url(${DeleteCutPng}) no-repeat 100%`,
  backgroundPositionX: 'center',
  backgroundPositionY: 'center',
  padding: 0,
  margin: 0,
  border: 'none',
};
